import type { LocationsListProviderProps } from "./locations-list-provider.type";

import { ListProvider } from "@/modules/list";

const LocationsListProvider = ({
  children,
  ...props
}: LocationsListProviderProps) => {
  return (
    <ListProvider endpoint="locations" withContext {...props}>
      {children}
    </ListProvider>
  );
};

export default LocationsListProvider;
